import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { AtlasGridSkeletonComponent } from '../atlas-grid-skeleton/atlas-grid-skeleton.component';
import { AtlasLandingpageSkeletonComponent } from '../atlas-landingpage-skeleton/atlas-landingpage-skeleton.component';
import { AtlasStorySkeletonComponent } from '../atlas-story-skeleton/atlas-story-skeleton.component';

/** What the initial atlas route leads to. */
type AtlasSkeletonKind = 'story' | 'view' | 'landing';

/**
 * Loading placeholder for the atlas: picks the skeleton matching what the
 * initial route will show - a report, a view or the landing page. Used both
 * while the user and while the stores are loading.
 */
@Component({
  selector: 'app-atlas-loading-skeleton',
  standalone: true,
  imports: [
    AtlasGridSkeletonComponent,
    AtlasLandingpageSkeletonComponent,
    AtlasStorySkeletonComponent,
  ],
  templateUrl: './atlas-loading-skeleton.component.html',
})
export class AtlasLoadingSkeletonComponent {
  readonly userStore = inject(ActiveUserStore);
  private readonly router = inject(Router);

  protected readonly kind = this.detectKind();

  /**
   * Determines what the current route leads to - a report (story route or
   * `?story=`), a view (bookmark route or `?topic=`) or the landing page.
   *
   * @return {AtlasSkeletonKind} The skeleton to show while loading.
   */
  private detectKind(): AtlasSkeletonKind {
    let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    while (route.firstChild) route = route.firstChild;
    if (
      route.data['entityType'] === 'Story' ||
      route.queryParamMap.get('story')
    ) {
      return 'story';
    }
    if (
      route.data['entityType'] === 'Bookmark' ||
      route.queryParamMap.get('topic')
    ) {
      return 'view';
    }
    return 'landing';
  }
}
